import { CheckBox } from '@idexx-laboratories/spot-react';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useStore } from '../../hooks/use-store';
import './RemoveSpeciesMappingModalContent.scss';

const RemoveSpeciesMappingModalContent = observer(() => {
  const { globalModalStore } = useStore();
  const modalState = globalModalStore.globalModalState;

  useEffect(() => {
    runInAction(() => (modalState.okDisabled = true));
  }, [modalState]);

  return (
    <div className='remove-species-mapping-content_container'>
      <p>
        This action will unmap your Cornerstone species and its associated breeds from
        Trupanion&apos;s species and breeds list.
      </p>
      <CheckBox
        id='remove-species-mapping-cb'
        size='small'
        label='Do you wish to continue?'
        checked={!modalState.okDisabled}
        aria-label='remove-species-mapping'
        onChange={e => runInAction(() => (modalState.okDisabled = !e.target.checked))}
        data-testid='remove-species-mapping-cb'
      />
    </div>
  );
});

export default RemoveSpeciesMappingModalContent;
